// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5hqPv","toggle":"styles_toggle__3QqGG","preview":"styles_preview__2q4ZR"};